import { observer } from "mobx-react";
import * as React from "react";
import { getJobCategoryOptions } from "../../constants";
import { applicationStore } from "../../stores/ApplicationStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { optionToString } from "../util/helpers";
import { ContentWrapper } from "./ContentWrapper";
import { THEME } from "../../theme/ThemeStore";

type Props = { imageUrl: string };

export const TopImage = observer(({ imageUrl }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <div
            style={{
                width: "100%",
                height: THEME.THEME_NAME === "dal" ? isMobile ? 95 : "clamp(140px, 22vw, 280px)" : isMobile ? 95 : "100%",
                maxHeight: 280,
                backgroundImage: `url(${imageUrl})`,
                backgroundSize: THEME.THEME_NAME === "dal" ? "contain" : "cover",
                backgroundRepeat: THEME.THEME_NAME === "dal" ? "no-repeat" : undefined,
                backgroundPosition: THEME.THEME_NAME === "dal" ? "left center" : "center top",
                display: "flex",
                marginLeft: isMobile && THEME.THEME_NAME === "dal" ? -30 : 0,
            }}
        >
            <ContentWrapper style={{ flexDirection: "column", justifyContent: "flex-end" }}>
                <h2
                    style={
                        isMobile
                            ? {
                                fontSize: 22,
                                lineHeight: "28px",
                                marginBottom: 0
                            }
                            : {
                                marginBottom: 20
                            }
                    }
                    className="topImageHeader"
                >
                    {THEME.THEME_NAME === "aaa" && (
                        optionToString(getJobCategoryOptions(), applicationStore.currentApplication.jobCategory) ||
                        applicationStore.currentApplication.jobCategory
                    )}
                </h2>
            </ContentWrapper>
        </div>
    );
});
